'use strict';

import angular from 'angular';

export default class GroupFormCtrl {
  model = {
    name: '',
    description: '',
    isActive: true,
    type: {}
  };
  // Auth; //TODO: add auth check

  constructor(
    $state,
    $stateParams,
    LoaderSvc,
    GroupSvc,
    GroupAuthSvc,
    GrpTypeSvc
  ) {
    var contextGrpId = $stateParams.ctxId;
    this.contextGrpId = contextGrpId;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.GrpTypeSvc = GrpTypeSvc;
    this.GroupSvc = GroupSvc;
    this.GroupAuthSvc = GroupAuthSvc;
    this.LoaderSvc = LoaderSvc;

    var that = this;

    var isCreate = $state.current.name.indexOf('new') !== -1;
    // create
    if(isCreate) {
      this.GroupAuthSvc.validatePermission(contextGrpId, 'group', 'C');

      this.submit = this.createGroup;
      var typeId = $stateParams.typeId;
      this.model.typeId = typeId;
      this.getGroupTypeAndParentsOnCreate(contextGrpId, typeId)
        .then(function(gt) {
          that.headerText = 'New ' + gt.name;
          that.submitText = 'Create ' + gt.name;
        });
      this.cancelSref = 'group.list({typeId:' + typeId + '})';

    // edit
    } else {
      this.GroupAuthSvc.validatePermission(contextGrpId, 'group', 'U');
      this.submit = this.updateGroup;
      var groupId = $stateParams.groupId;
      that.groupId = groupId;
      this.getGroupTypeAndParentsOnEdit(groupId)
        .then(function(gt) {
          that.headerText = `Edit ${gt ? gt.name : ''}`;
          that.submitText = `Update ${gt ? gt.name : ''}`;
        });

      this.cancelSref = 'group.view.summary({groupId:' + groupId + '})';
    }
  }

  // groupId = ancestor
  getGroupParents(groupId, typeId) {
    var that = this;
    return that.GroupSvc.query({groupId, groupTypeId: typeId}).$promise
      .then(function(groups) {
        return groups;
      });
  }

  getGroupTypeAndParentsOnCreate(groupId, typeId) {
    var that = this;
    return this.GrpTypeSvc.get({groupId, id: typeId}).$promise
      .then(function(gt) {
      // if type has no parent, use the defined for group as parent
        if(gt && gt.hierarchyLevel === 1) {
        //NOTE: this does not currently filter on active parent groups
          that.parentGroups = [gt.definedByGroup];
          that.model.parent = gt.definedByGroup;
          return gt;
        }

        var parentTypeId = gt.parent.id;
        return that.getGroupParents(groupId, parentTypeId)
          .then(function(groups) {
            that.parentGroups = groups;
            return gt;
          });
      });
  }

  getGroupTypeAndParentsOnEdit(groupId) {
    var that = this;
    return this.GroupSvc.get({groupId}).$promise
      .then(function(editGroup) {
        var groupCopy = angular.copy(editGroup);
        delete groupCopy.ancestors;
        that.model = groupCopy;
        return editGroup;
      })
      .then(function() {
        return that.GrpTypeSvc.getType({groupId}).$promise
          .then(function(gt) {
            if(gt.hierarchyLevel === 1) {
              return gt;
            }
            /**
         * TODO fix this - not returning root group anymore
         * if no parent type, use defined by
         */
            var parentType = gt.parent;
            that.model.typeId = gt.id;
            if(!parentType) { return null; }
            // if type's parent is a root group use that
            if(!parentType.hierarchyLevel === 1) {
              that.parentGroups = [parentType];
              that.model.parent = parentType;
              return gt;
            }
            var parentTypeId = parentType.id;
            // otherwise get groupParents
            return that.getGroupParents(that.contextGrpId, parentTypeId)
              .then(function(groups) {
                var parentGrp = that.model.parent;
                that.parentGroups = groups.map(function(g) {
                  var option = {id: g.id, name: g.name};
                  if(parentGrp && g.id === parentGrp.id) {
                    that.model.parent = option;
                  }
                  return option;
                });
              })
              .then(function() { return gt; });
          });
      });
  }

  createGroup() {
    var that = this;
    that.LoaderSvc.start();
    that.GroupSvc.create(this.model).$promise
      .then(function(group) {
        that.LoaderSvc.stopSuccess('Group Created');
        that.$state.go('group.view.summary', {groupId: group.id});
      }).catch(function(err) {
        that.LoaderSvc.stopError(err);
      });
  }

  updateGroup() {
    var that = this;
    that.LoaderSvc.start();

    this.GroupSvc.update(this.model).$promise.then(function() {
      /**
       * TODO: refresh nav if group name changed
       */
      that.$state.go('group.view.summary', {groupId: that.groupId});
      that.LoaderSvc.stopSuccess('Group Updated');
    })
      .catch(function(err) {
        that.LoaderSvc.stopError(err);
      });
  }
}

GroupFormCtrl.$inject = [
  '$state',
  '$stateParams',
  'LoaderSvc',
  'GroupSvc',
  'GroupAuthSvc',
  'GrpTypeSvc'
];
